import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'dropdown',
    setup(__props, { expose: __expose }) {
        __expose();
        const isOpen = ref(false);
        const __returned__ = { isOpen };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
